import { useEffect, useRef } from 'react'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import { keepsSidebarListOpen } from 'Pods/ThreeDStudio/constants'
import { setIsSidebarOpen, settleInitialSidebarState } from 'Pods/ThreeDStudio/Store/actions/ui'

import { getBreakPoint } from 'Utils/useBreakpoint'

// On mobile (< 640px) the open library sidebar covers the workspace, hiding the
// studio behind the model card list. Collapse the sidebar once on initial load
// so mobile users land on the workspace: /ai opens on Generate (the default
// panel) and /ai-3d-model-generator/3d-models/<slug> opens on the model viewer. The exact
// community gallery routes (/ai-3d-model-generator/3d-models, /ai-image-generator/images)
// keep their list. Desktop is untouched.
//
// It runs on the first client effect: nothing it reads waits on /load-services.js, and the
// server-rendered open sidebar is only disguised as the collapsed rail until it has run
// (sidebar--pending-collapse). Critical-style extraction keeps the server markup as is.
function useInitialMobilePanel({ extractingCoreStyles = false } = {}) {
  const location = useLocation()
  const isGalleryRoute = keepsSidebarListOpen(location?.pathname)

  const hasRunRef = useRef(false)

  useEffect(() => {
    if (hasRunRef.current || extractingCoreStyles) {
      return
    }

    hasRunRef.current = true

    if (!isGalleryRoute && getBreakPoint(window.innerWidth) === 'xs') {
      setIsSidebarOpen(false)
    }
    settleInitialSidebarState()
  }, [extractingCoreStyles, isGalleryRoute])
}

export default useInitialMobilePanel
